import { render, staticRenderFns } from "./editorBottomMenu.vue?vue&type=template&id=0a5e4b51&scoped=true"
import script from "./editorBottomMenu.vue?vue&type=script&lang=js"
export * from "./editorBottomMenu.vue?vue&type=script&lang=js"
import style0 from "./editorBottomMenu.vue?vue&type=style&index=0&id=0a5e4b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e4b51",
  null
  
)

export default component.exports